const sellOnline = process.env.REACT_APP_SELL_ONLINE === 'true'

export default {
  sellOnline
}
